import { Stash } from 'src/app/features/stash/Stash'
import { Assistance } from '../../../../../models/assistance'

export class AssistanceStash extends Stash<Assistance> {
  TAG = 'AssistanceStash'

  protected isChangedImpl() {
    console.log(this.TAG, 'isChanged', this.current.statusId, this.previous.statusId)

    if (this.current.clientId !== this.previous.clientId) return true
    if (this.current.statusId !== this.previous.statusId) return true
    if (this.current.id !== this.previous.id) return true
    if (this.current.plannedTo !== this.previous.plannedTo) return true
    if (this.current.plannedFrom !== this.previous.plannedFrom) return true
    if (this.current.preferredAssistantGenderId !== this.previous.preferredAssistantGenderId) return true
    if (this.current.advancedAssistantNeeded !== this.previous.advancedAssistantNeeded) return true
    if (this.current.strongAssistantNeeded !== this.previous.strongAssistantNeeded) return true
    if (this.current.assistantAssignments.areAssignmentsDifferent(this.previous.assistantAssignments)) return true

    return false
  }
}
